import React, { useCallback, useState } from 'react'
import { IconButton, useMediaQuery } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { WrapSideBar, DrawerStyles, SideBarStyles } from './Style'
import { useDispatch } from 'react-redux';
import { SideBarItems } from '.'
import { CacheProvider } from '@emotion/react';
import { cacheLtr } from 'styles/theme';

const SideBar = () => {
    const [open, setOpen] = useState(false);
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'), { noSsr: true })

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    }
    
    return (
        <SideBarStyles>
            {isSmallScreen ? (
                <div className='menu-icon'>
                    <IconButton className='drawer-button' edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                        <Menu />
                    </IconButton>
                    <CacheProvider value={cacheLtr}>
                        <DrawerStyles anchor='right' open={open} onClose={toggleDrawer(false)}>
                            <SideBarItems closeDrawer={toggleDrawer(false)} />
                        </DrawerStyles>
                    </CacheProvider>
                </div>
            ) :
                <WrapSideBar>
                    <SideBarItems />
                </WrapSideBar>
            }
        </SideBarStyles>
    )
}

export default SideBar